function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M10,10c-1.103,0-2,0.897-2,2c0,0.483,0.18,0.951,0.5,1.314V15.5C8.5,15.776,8.724,16,9,16h2c0.276,0,0.5-0.224,0.5-0.5 v-2.186C11.82,12.951,12,12.483,12,12C12,10.897,11.103,10,10,10z M10.666,12.739C10.56,12.834,10.5,12.969,10.5,13.11V15h-1v-1.89 c0-0.142-0.06-0.276-0.166-0.371C9.119,12.545,9,12.282,9,12c0-0.551,0.449-1,1-1s1,0.449,1,1 C11,12.282,10.881,12.545,10.666,12.739z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5,7H16c0-3.309-2.691-6-6-6S4,3.691,4,7H3.5C2.635,7,1,7.522,1,9.5v7C1,17.364,1.522,19,3.5,19h13 c0.864,0,2.5-0.522,2.5-2.5v-7C19,8.635,18.478,7,16.5,7z M10,2c2.757,0,5,2.243,5,5H5C5,4.243,7.243,2,10,2z M18,16.5 c0,1.411-1.252,1.497-1.5,1.5h-13c-1.412,0-1.497-1.252-1.5-1.5v-7C2,8.09,3.249,8.003,3.502,8H16.5c1.411,0,1.497,1.252,1.5,1.5 V16.5z"
}));

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1f9f7a35.svg";
export { ForwardRef as ReactComponent };